import { render } from "./CtrlButton.vue?vue&type=template&id=683b60de&scoped=true"
import script from "./CtrlButton.vue?vue&type=script&lang=js"
export * from "./CtrlButton.vue?vue&type=script&lang=js"

import "./CtrlButton.vue?vue&type=style&index=0&id=683b60de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683b60de"]])

export default __exports__